var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        { staticClass: "image-list" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.field, "label-width": "120px" }
            },
            [
              _vm._l(_vm.field.def_val, function(item, index) {
                return _c(
                  "el-form-item",
                  {
                    key: index,
                    staticClass: "input-row",
                    attrs: {
                      label: _vm.field.desc + "(" + (index + 1) + ")",
                      prop: "def_val[" + index + "].val",
                      rules: _vm.fieldRules
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "field-input",
                      attrs: {
                        placeholder: "请填写'" + _vm.field.desc + "'的内容"
                      },
                      model: {
                        value: item.val,
                        callback: function($$v) {
                          _vm.$set(item, "val", $$v)
                        },
                        expression: "item.val"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "remove-btn",
                        on: {
                          click: function($event) {
                            return _vm.remove(index)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { staticClass: "add-btn", on: { click: _vm.add } },
                    [_vm._v("+")]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-027cec92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-027cec92","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/imageList.vue
// module id = 1210
// module chunks = 7